import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { BulkSelectEmployeeDialogComponent } from '@app/components';
import { Columns, Row } from '@app/components/simple-table/simple-table.component';
import { QueryFetcher } from '@app/models/core/query-fetcher.model';
import { BaseForm } from '@forms/base.form';
import { Employee } from '@models/employee/employee.model';

const mapEmployeesToRow = (employee: Employee): Row => {
    return {
        cells: [{ employee, isAvatar: true }, employee.job?.title, employee.department?.name],
    };
};
@Component({
    selector: 'app-form-bulk-review-reviewees',
    templateUrl: './bulk-review-reviewees.template.html',
})
export class BulkReviewRevieweesForm extends BaseForm {
    @ViewChild('selectEmployees', { static: true }) selectEmployees: BulkSelectEmployeeDialogComponent;
    @Output() onSelectedEmployeesChange: EventEmitter<Employee[]> = new EventEmitter<Employee[]>();

    selectedEmployees: Employee[];

    columns: Columns[] = [
        { columnName: 'performance.bulk-review.selectReviewees.reviewee', columnSpan: 'columns-5' },
        { columnName: 'account.position', columnSpan: 'columns-3' },
        { columnName: 'account.department', columnSpan: 'columns-3' },
    ];

    rows: Row[] = [];
    computedRows: Row[] = [];

    showBulkSelectDialog(): void {
        this.selectEmployees.show<Employee[]>(this.selectedEmployees).then((selected: Employee[]) => {
            if (selected) {
                this.selectedEmployees = selected;
                this.updateSelection();
            }
        });
    }

    onSearch(searchQuery: string | null): void {
        if (searchQuery === null) {
            this.rows = this.computedRows;
            return;
        }

        const nameIncludesSearchQuery = (row: Row): boolean =>
            (row.cells[0] as { employee: Employee; isAvatar: boolean }).employee.fullName
                .toLowerCase()
                .includes(searchQuery.toLocaleLowerCase());

        this.rows = this.computedRows.filter(nameIncludesSearchQuery);
    }

    removeEmployee(index: number): void {
        this.selectedEmployees.splice(index, 1);
        this.updateSelection();
    }

    addMoreIncludesToBulkSelectDialogEmployeeQuery(query: QueryFetcher): QueryFetcher {
        return query.with(['activePeers', 'manager', 'activeDirectReports']);
    }

    trackByRow(index, item) {
        return item.cells[0].employee.id;
    }

    private updateSelection(): void {
        this.rows = this.computedRows = this.selectedEmployees.map(mapEmployeesToRow);
        this.onSelectedEmployeesChange.emit(this.selectedEmployees.slice(0));
    }
}
